import { panMapTo } from './panMapToCoordinate';

interface GlobalMapHandles {
  mapProvider: unknown;
  mapInstance: unknown;
}

const DEFAULT_GLOBAL_MAP_ZOOM = 17;

/**
 * Read the active map provider and instance from the global RSOS namespace.
 */
function getGlobalMapHandles(): GlobalMapHandles {
  const rsos = (
    window as Window & {
      __RSOS?: Record<string, Record<string, unknown>>;
    }
  ).__RSOS;

  return {
    mapProvider: rsos?.map?.mapProvider,
    mapInstance: rsos?.map?.mapInstance,
  };
}

/**
 * Pan the global map to a coordinate when the map has initialized.
 */
function panToGlobalMap(
  latitude: number,
  longitude: number,
  zoom: number = DEFAULT_GLOBAL_MAP_ZOOM,
): void {
  const { mapProvider, mapInstance } = getGlobalMapHandles();

  panMapTo({
    mapProvider,
    mapInstance,
    latitude,
    longitude,
    zoom,
  } as Parameters<typeof panMapTo>[0]);
}

export { panToGlobalMap, DEFAULT_GLOBAL_MAP_ZOOM };
